import { useEffect, useState } from 'react';
import { fetchSystemDayYmd } from '../utils/recentDealsDate';

/**
 * Default recent-deals blotter filter date = portfolio system day.
 */
export function useRecentDealsFilterDate() {
  const [filterDateYmd, setFilterDateYmd] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const day = await fetchSystemDayYmd();
      if (mounted) {
        setFilterDateYmd(day);
        setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return { filterDateYmd, setFilterDateYmd, loading };
}
